/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseRubricRow } from './BaseRubricRow';
import { Fraction } from './Fraction';
const ContinuousRubricRowParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('continuous')],
    ['minPoints', Fraction, 'min_points'],
    ['maxPoints', Fraction, 'max_points'],
]), BaseRubricRow);
export class ContinuousRubricRow extends BaseRubricRow {
    static decode(input) {
        return ContinuousRubricRowParser.decode(input).map(res => new ContinuousRubricRow(res));
    }
    static unsafeDecode(input) {
        return ContinuousRubricRow.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ContinuousRubricRowParser.encode(data);
    }
    static schema() {
        return ContinuousRubricRowParser.schema();
    }
}
